var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// @ts-nocheck
/* global google */
import { debounce, find } from 'lodash-es';
import Component from 'navigation/component/Component';
import promise from 'helpers/promise';
import config from 'core/config';
import store from 'store/store';
import validators from '../form/components/validators';
var _gmap;
var gmap = function () {
    if (_gmap)
        return _gmap.promise;
    _gmap = promise.defer();
    var url = "//maps.googleapis.com/maps/api/js?key=".concat(config.gmapKey, "&libraries=places&language=").concat(store.lang.get(), "&callback=onGmapReady");
    var script = document.createElement('script');
    script.setAttribute('src', url);
    document.body.appendChild(script);
    window.onGmapReady = function () {
        _gmap.ready = true;
        _gmap.resolve(new google.maps.places.AutocompleteSessionToken());
        window.onGmapReady = null;
    };
    return _gmap.promise;
};
var getField = function (address, addressKey) {
    return find(address, function (a) { return ~a.types.indexOf(addressKey); });
};
var getFieldValue = function (address, addressKey, format) {
    if (!format)
        format = function (v) { return v && v.long_name; };
    var result = format(getField(address, addressKey));
    if (result && result !== '[no name]')
        return result;
};
var GooglePlacesField = /** @class */ (function (_super) {
    __extends(GooglePlacesField, _super);
    function GooglePlacesField(el, refs) {
        var _this = _super.call(this, el) || this;
        Object.defineProperty(_this, "country", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "initGmap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (token) {
                if (_this._flushed)
                    return;
                _this.token = token;
                _this.autocompleteService = new google.maps.places.AutocompleteService();
                _this.placeService = new google.maps.places.PlacesService(document.createElement('div'));
            }
        });
        Object.defineProperty(_this, "focusOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                setTimeout(function () { _this.suggestionsDiv.classList.remove('opened'); }, 200);
            }
        });
        Object.defineProperty(_this, "onInputOrFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                var search = _this.streetInput.value;
                if (search)
                    _this.streetField.classList.add('loading');
                if (_this.autocompleteService && event.inputType === 'insertText')
                    _this.debouncedSearch(search);
            }
        });
        Object.defineProperty(_this, "debouncedSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: debounce(function (search) {
                if (!search)
                    return _this.updateSuggestions();
                var request = {
                    input: search,
                    types: ['address'],
                    language: store.lang.get(),
                    sessionToken: _this.token,
                    componentRestrictions: {
                        country: _this.country
                    }
                };
                var lastSearch = Date.now();
                _this.lastSearch = lastSearch;
                _this.autocompleteService.getPlacePredictions(request, function (results, status) {
                    if (_this.lastSearch === lastSearch)
                        _this.streetField.classList.remove('loading');
                    if (status !== google.maps.places.PlacesServiceStatus.OK)
                        return;
                    _this.updateSuggestions(results.map(function (result) { return ({
                        label: result.structured_formatting.main_text,
                        description: result.structured_formatting.secondary_text,
                        value: result.structured_formatting.main_text,
                        placeId: result.place_id
                    }); }));
                });
            }, 200)
        });
        Object.defineProperty(_this, "onSuggestionClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                event.preventDefault();
                var info = JSON.parse(event.currentTarget.getAttribute('data-info'));
                _this.placeService.getDetails({
                    placeId: info.placeId,
                    language: store.lang.get(),
                    fields: ['address_component'],
                    sessionToken: _this.token
                }, function (result, status) {
                    if (status !== google.maps.places.PlacesServiceStatus.OK)
                        return;
                    _this.emit('select', _this.extractAddress(result.address_components, info));
                    _this.updateSuggestions();
                    _this.suggestionsDiv.classList.toggle('opened', false);
                    // this.fillAddress(this.extractAddress(result.address_components, info))
                });
            }
        });
        // fillAddress = (address) => {
        //   each(address, (value, key) => {
        //     const input = this.el.querySelector(`[name="${key}"]`)
        //     if (!input) return
        //     input.value = value
        //   })
        //   this.updateSuggestions()
        // }
        Object.defineProperty(_this, "extractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (addressDetails, addressInfo) {
                var object = { address: addressInfo.label };
                if (!object.address || !validators.street.isValidSync(object.address)) {
                    var street = getFieldValue(addressDetails, 'route');
                    var streetNumber = getFieldValue(addressDetails, 'street_number');
                    if (street && streetNumber)
                        object.address = "".concat(streetNumber, " ").concat(street);
                    else if (street)
                        object.address = street;
                }
                object.city = getFieldValue(addressDetails, 'locality');
                if (!object.city)
                    object.city = getFieldValue(addressDetails, 'postal_town');
                if (!object.city)
                    object.city = getFieldValue(addressDetails, 'sublocality');
                if (!object.city)
                    object.city = getFieldValue(addressDetails, 'administrative_area_level_1');
                object.country = getFieldValue(addressDetails, 'country', function (v) { return v && v.short_name; });
                object.countryName = getFieldValue(addressDetails, 'country', function (v) { return v && v.long_name; });
                object.postcode = getFieldValue(addressDetails, 'postal_code');
                var postcodeSuffix = getFieldValue(addressDetails, 'postal_code_suffix');
                if (object.postcode && postcodeSuffix)
                    object.postcode += '' + postcodeSuffix;
                object.state = getFieldValue(addressDetails, 'administrative_area_level_1', function (v) { return v && v.short_name; });
                // object.region2 = getFieldValue(addressDetails, 'administrative_area_level_2', v => v && v.short_name)
                if (object.country === 'KR' && object.postcode)
                    delete object.postcode;
                object.phone_code = object.country;
                Object.keys(object).forEach(function (key) { return !object[key] && delete object[key]; });
                return object;
            }
        });
        _this.parseForm();
        gmap().then(function (token) { return _this.initGmap(token); });
        return _this;
    }
    Object.defineProperty(GooglePlacesField.prototype, "initialized", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            _super.prototype.initialized.call(this);
        }
    });
    Object.defineProperty(GooglePlacesField.prototype, "parseForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.streetInput = this.el;
            this.streetField = this.streetInput.parentNode.parentNode;
            this.streetField.classList.add('with-suggestions');
            this.suggestionsDiv = document.createElement('div');
            this.suggestionsDiv.className = 'field__suggestions';
            this.streetField.appendChild(this.suggestionsDiv);
        }
    });
    Object.defineProperty(GooglePlacesField.prototype, "bindEvents", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (add) {
            if (add === void 0) { add = true; }
            var method = add ? 'addEventListener' : 'removeEventListener';
            this.el[method]('focusin', this.onInputOrFocus);
            this.el[method]('focusout', this.focusOut);
            this.streetInput[method]('input', this.onInputOrFocus);
        }
    });
    Object.defineProperty(GooglePlacesField.prototype, "clearSuggestions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.suggestions && this.suggestions.forEach(function (div) {
                div.removeEventListener('click', _this.onSuggestionClick);
            });
            this.suggestions = null;
        }
    });
    Object.defineProperty(GooglePlacesField.prototype, "updateSuggestions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (suggestions) {
            var _this = this;
            this.clearSuggestions();
            if (!suggestions)
                return;
            this.suggestionsDiv.classList.toggle('opened', true);
            this.suggestionsDiv.innerHTML = '';
            this.suggestions = suggestions.map(function (suggestion) {
                var label = suggestion.label, description = suggestion.description;
                var div = document.createElement('button');
                div.className = 'field__suggestion';
                div.setAttribute('data-info', JSON.stringify(suggestion));
                div.addEventListener('click', _this.onSuggestionClick);
                var alreadyTyped = _this.el.value;
                var remaining;
                if (label.toLowerCase().includes(alreadyTyped.toLowerCase())) {
                    remaining = label.slice(alreadyTyped.length);
                }
                else {
                    remaining = label;
                    alreadyTyped = '';
                }
                div.innerHTML = "\n        <h5 class=\"field__suggestion-title\"> <span class=\"field__suggestion__already-typed\">".concat(alreadyTyped, "</span>").concat(remaining, ", ").concat(description, "</h5>\n      ");
                _this.suggestionsDiv.appendChild(div);
                return div;
            });
        }
    });
    Object.defineProperty(GooglePlacesField.prototype, "flush", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.clearSuggestions();
            _super.prototype.flush.call(this);
        }
    });
    return GooglePlacesField;
}(Component));
export default GooglePlacesField;
